import { ExclamationCircleIcon, XIcon } from '@heroicons/react/outline';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Modal from '@material-ui/core/Modal';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React from 'react';

import ajaxPromise from '../../utils/ajaxPromise';

export default function NewInviteModal({ showModal, setShowModal, invitedBy, organizationName }) {
  const [backendError, setBackendError] = React.useState(false);
  const [loadingLink, setLoadingLink] = React.useState(false);
  const [declineInviteConfirmation, setDeclineInviteConfirmation] = React.useState(false);

  const router = useRouter();
  const handleJoinOrganization = (accept) => {
    const url = accept ? '/api/organizations/invite/accept' : '/api/organizations/invite/decline';
    setLoadingLink(true);
    setBackendError(false);
    ajaxPromise(url, 'POST')
      .then(() => {
        setBackendError(false);
        router.reload();
      })
      .catch(() => setBackendError(true));
  };
  return (
    <Modal
      aria-labelledby='transition-modal-title'
      aria-describedby='transition-modal-description'
      open={showModal}
      onClose={() => setShowModal(false)}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Fade in={showModal}>
        <div className='inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6'>
          <div className='flex justify-end'>
            <button
              type='button'
              className=' bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 right-0'
              onClick={() => setShowModal(false)}
            >
              <XIcon className='h-6 w-6' aria-hidden='true' />
            </button>
          </div>
          <div>
            <ExclamationCircleIcon className='h-9 w-9 text-exact-blue m-auto' />
            <div className='mt-3 text-center sm:mt-5'>
              <h3 as='h3' className='text-lg leading-6 font-medium text-gray-900'>
                Pending Invite
              </h3>
              <div className='mt-2'>
                <p className='text-sm text-gray-500'>
                  {invitedBy} has invited you to join {organizationName}
                  &apos;s team on ExactBuyer
                </p>
              </div>
            </div>
          </div>
          <div className='mt-5 sm:mt-6'>
            <button
              type='button'
              className='inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-exact-blue text-base font-medium text-white hover:bg-indigo-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm'
              onClick={() => handleJoinOrganization(true)}
            >
              Accept
            </button>
            <button
              type='button'
              className='inline-flex my-2 justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-gray-300 text-base font-medium text-gray-800 hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm'
              onClick={() => setDeclineInviteConfirmation(true)}
            >
              Decline
            </button>
          </div>
          {declineInviteConfirmation && (
            <>
              <div className='mt-5'>Are you sure you want to decline the invite?</div>
              <button
                type='button'
                className='inline-flex my-2 justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-700 text-base font-medium text-white hover:bg-red-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm'
                onClick={() => handleJoinOrganization(false)}
              >
                Yes, decline the invite
              </button>
              <button
                type='button'
                className='inline-flex my-2 justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 text-white  bg-gray-700 text-base font-medium  hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm'
                onClick={() => setShowModal(false)}
              >
                No, revisit this later
              </button>
            </>
          )}
        </div>
      </Fade>
    </Modal>
  );
}
